<template>
  <div class="grid grid-cols-1 md:grid-cols-12 gap-4 items-start">
    <Card
      v-if="$slots.left"
      class="hidden md:block md:col-span-4"
      :class="{ 'md:!col-span-3': !!$slots.extra }"
    >
      <slot name="left"></slot>
    </Card>
    <div
      class="md:col-span-12"
      :class="{
        'md:!col-span-8':
          (!!$slots.extra || !!$slots.left) &&
          !(!!$slots.extra && !!$slots.left),
        'md:!col-span-6': !!$slots.extra && !!$slots.left,
      }"
    >
      <slot></slot>
    </div>
    <Card
      v-if="$slots.extra"
      class="hidden md:block md:col-span-4"
      :class="{ 'md:!col-span-3': !!$slots.left }"
    >
      <slot name="extra"></slot>
    </Card>
  </div>
</template>
